import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid mt-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col text-left ml-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Notification")
], -1)
const _hoisted_3 = { class: "col text-right mr-3" }
const _hoisted_4 = { class: "ml-2" }

export function render(_ctx, _cache) {
  const _component_p_avatar = _resolveComponent("p-avatar")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_p_badge = _resolveComponent("p-badge")
  const _component_router_link = _resolveComponent("router-link")
  const _component_p_menu = _resolveComponent("p-menu")
  const _directive_badge = _resolveDirective("badge")
  const _directive_ripple = _resolveDirective("ripple")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.total_notif > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_p_avatar, {
          key: 0,
          icon: _ctx.is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-bell',
          shape: "circle",
          type: "button",
          "aria-haspopup": "true",
          "aria-controls": "overlay_menu",
          style: {"background-color":"#2196f3","color":"#ffffff"},
          onClick: _ctx.toggle
        }, null, 8, ["icon", "onClick"])), [
          [
            _directive_badge,
            _ctx.total_notif,
            void 0,
            { danger: true }
          ]
        ])
      : (_openBlock(), _createBlock(_component_p_avatar, {
          key: 1,
          icon: _ctx.is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-bell',
          shape: "circle",
          type: "button",
          "aria-haspopup": "true",
          "aria-controls": "overlay_menu",
          style: {"background-color":"#2196f3","color":"#ffffff"},
          onClick: _ctx.toggle
        }, null, 8, ["icon", "onClick"])),
    _createVNode(_component_p_menu, {
      class: "md:w-15rem",
      ref: "menu",
      id: "overlay_menu",
      model: _ctx.items,
      popup: true
    }, {
      start: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_p_avatar, {
              icon: _ctx.is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-sync',
              shape: "circle",
              type: "button",
              onClick: _ctx.refresh
            }, null, 8, ["icon", "onClick"])
          ])
        ])
      ]),
      item: _withCtx(({ item, props }) => [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, _mergeProps({
          to: item.to ?  item.to : '',
          class: "flex align-items-center"
        }, props.action), {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
            (item.total)
              ? (_openBlock(), _createBlock(_component_p_badge, {
                  key: 0,
                  severity: "warning",
                  class: "ml-auto",
                  value: item.total
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040, ["to"])), [
          [_directive_ripple]
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}